export const mxServicePhone ="+529717807622"
export const suyoServicePhone ="+51971780762"